export enum GtmEventType {
  ClickedOnSeeClientCard = 'contact_cliked_on_see_client_card',
  ClickedOnTalkToAdvisor = 'contact_clicked_on_talk_to_advisor',
  ClickedOnFaq = 'contact_clicked_on_faq',
  ClickedOnAppointment = 'contact_clicked_on_appointment',
  ClickedOnMailAssistance = 'contact_clicked_on_mail_assistance',
  ClickedOnSignDocument = 'contact_cliked_on_sign_document',
  ClickedOnAddInsurance = 'contact_cliked_on_add_insurance',
  ClickedUploadedDocument = 'contact_uploaded_document',
  ClickedOnAddDocument = 'contact_cliked_on_add_document',
  ClickedOnAskInvoiceDuplicata = 'contact_clicked_on_ask_invoice_duplicata',
  ClickedOnAskPaymentSplittingChange = 'contact_clicked_on_ask_payment_splitting_change',
  ClickedOnAskNewGuarantee = 'contact_clicked_on_ask_new_guarantee',
  ClickedOnAskInsuranceCertificateDuplicata = 'contact_clicked_on_ask_insurance_certificate_duplicata',
  ClickedOnContractTransfer = 'contact_cliked_on_contract_transfer',
  ClickedOnAddNewContract = 'contact_cliked_on_add_new_contract',
  ClickedOnCancelSimulation = 'contact_cancelled_simulation',
  ClickedOnResumeSimulation = 'contact_resumed_simulation',
  ClickedOnBlogPost = 'contact_cliked_on_blogpost',
  ClickedOnAddClaim = 'contact_cliked_on_add_claim',
  ClickedOnRegisterClaim = 'contact_cliked_on_register_claim',
  ClickedOnCallAssistance = 'contact_cliked_on_call_assistance',
  ClickedOnMarketingBanner = 'contact_cliked_on_marketing_banner',
  ClickedOnModifyContract = 'contact_cliked_on_modify_contract',
  ClickedOnAccountReferral = 'contact_cliked_on_account_referral',
  ClickedOnReferralCta = 'contact_cliked_on_i_refer',
  ClickedOnKnowMoreAboutReferralCta = 'contact_cliked_on_know_more_about_referral',
  AskedForInformationTransferOnContractsPage = 'contact_asked_for_information_transfer_on_contracts_page',
  ClaimClickedFromHomepage = 'claims_detail_clicked_from_homepage',
  ClaimClickedFromContract = 'claims_detail_clicked_from_contract',
  ClaimPageViewed = 'claims_detail_page_viewed',
  ClaimSummaryClicked = 'claims_detail_summary_clicked',
  ClaimDocumentsClicked = 'claims_detail_documents_clicked',
  ClaimDeclarationClicked = 'claims_detail_declaration_clicked',
  MyClaimsClickedFromHomepage = 'claims_clicked_from_homepage',
  MyClaimsClickedFromAccount = 'claims_clicked_from_account',
  AskedForB2BOffer = 'asked_for_b2_offer',
  AskedForB2BTransfer = 'asked_for_b2b_transfer'
}
export interface GtmEventParameters {
  name: GtmEventType
  category: string
  label: GtmEventType
  value?: any
}
